import React from 'react';
import Navigation from './Navigation';

function App() {
  return (
    <div className="appContainer">
      <div className="headerBanner">
        <h1 className="appName">IKO Veileder</h1>

        <div className="appBanner">
          <a
            href="https://apps.apple.com/no/app/iko-veileder/id6739162323"
            target="_blank"
            rel="noopener noreferrer"
            className="downloadLink">
            <img
              src="/static/apple.png"
              alt="Download on the App Store"
              className="appIcon"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=no.ftl.ikoveileder"
            target="_blank"
            rel="noopener noreferrer"
            className="downloadLink">
            <img
              src="/static/google.png"
              alt="Get it on Google Play"
              className="appIcon"
            />
          </a>
        </div>

        <a
          href="https://finntannlegen.no"
          target="_blank"
          rel="noopener noreferrer"
          className="websiteLink">
          www.FinnTannlegen.no
        </a>
      </div>

      <Navigation />
    </div>
  );
}

export default App;
